var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleIndividuals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1643.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Individuals",
    transform: "translate(2352.000000, 1643.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.44,12.294 L24.613,18.727 L24.613,27.952 C24.613,30.187 26.424,32 28.66,32 L29.935,32 L29.935,19.613 L32,19.613 L32,6.978 C30.897,6.478 29.676,6.193 28.386,6.193 C28.365,6.193 28.343,6.193 28.322,6.193 C25.176,6.216 22.877,9.2 23.44,12.294 M3.677,6.193 C3.656,6.193 3.634,6.193 3.612,6.193 C2.323,6.193 1.103,6.478 0,6.978 L0,19.613 L2.064,19.613 L2.064,32 L3.339,32 C5.575,32 7.387,30.187 7.387,27.952 L7.387,18.727 L8.559,12.294 C9.123,9.2 6.822,6.216 3.677,6.193 M16,16.516 C14.012,16.516 12.387,18.141 12.387,20.128 L12.387,24.774 L13.935,24.774 L13.935,29.935 C13.935,31.075 14.859,32 16,32 C17.14,32 18.064,31.075 18.064,29.935 L18.064,24.774 L19.613,24.774 L19.613,20.128 C19.613,18.141 17.987,16.516 16,16.516 M16,15.509 C17.432,15.509 18.592,14.348 18.592,12.915 C18.592,11.483 17.432,10.322 16,10.322 C14.567,10.322 13.407,11.483 13.407,12.915 C13.407,14.348 14.567,15.509 16,15.509 M26.322,5.162 C27.748,5.162 28.903,4.006 28.903,2.58 C28.903,1.155 27.748,0 26.322,0 C24.897,0 23.742,1.155 23.742,2.58 C23.742,4.006 24.897,5.162 26.322,5.162 M9.036,2.58 C9.036,4.006 7.881,5.162 6.456,5.162 C5.03,5.162 3.875,4.006 3.875,2.58 C3.875,1.155 5.03,0 6.456,0 C7.881,0 9.036,1.155 9.036,2.58",
    id: 35
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleIndividuals);
export default __webpack_public_path__ + "static/media/life-and-people-individuals.b5077dd4.svg";
export { ForwardRef as ReactComponent };